/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';
import classnames from 'classnames';
import Loading from 'app/components/common/Loading.jsx';
import * as _ from "underscore";
import DateDisplay from 'app/components/common/DateDisplay.jsx';
import { Link } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class SocialLogPanel extends React.Component {
    componentDidUpdate(prevProps, prevState) {

        // in certain cases this can cause repeat calls to social log, but not sure how to get around that
        if ((prevProps.app.loading.SOCIAL_LIST === true && this.props.app.loading.SOCIAL_LIST === false) ||
            (prevProps.app.loading.SOCIAL_SHOW === true && this.props.app.loading.SOCIAL_SHOW === false)) {
            this.props.getSocialLog(this.props.router.params.socialId);
        }

    }

    componentWillUnmount() {
        // get the latest version of the social data to have the updated errlogResetTs handy
        // for social detail
        this.props.getSocial(this.props.router.params.socialId);
    }

    render() {

        let errorBlock = null,
            adviceBlock = null,
            logBlock = null,
            social = null,
            constants = this.props.app.config.constants;

        // no log entries if the social has been deactivated/inaccessible for more than
        // a few days
        if (this.props.app.loading.SOCIAL_LOG || this.props.app.loading.SOCIAL_LIST) {
            return (
                <Loading/>
            );
        }

        social = this.props.findSocial(this.props.router.params.socialId);

        if (social === null || social.log === undefined || social.log.length === 0) {
            logBlock = (
                <div className="log-advice">
                    {"No errors to report"}
                </div>
            );
        } else {
            if (social.log.length) {
                adviceBlock = (
                    <div className="log-advice">
                        For tips on diagnosing problems with your social, see the <a className="faq-link" href="https://support.dlvrit.com/hc/en-us/sections/200052364-FAQs" target="_blank">Social FAQ.</a>
                    </div>
                );
            }

            if (social.log.length) {
                logBlock = (
                    <ul className="log-list">
                        {social.log.map((log, i) => {
                            let logEntryClass = classnames('log-entry', {
                                    'error': (log.type === 'error')
                                }),
                                upgradeLink = null,
                                msg = log.msg;

                            if (log.msg.match("Daily post limit reached")) {
                                if ([1, 16].indexOf(this.props.user.detail.pubLevel) !== -1 && social.psID !== constants.POST_SVC_TWITTER) {
                                    upgradeLink = (
                                        <Link style={{marginLeft: '10px', textDecoration: 'underline'}} to="/account/subscription/new">Get unlimited posting</Link>
                                    );
                                }
                            }

                            if (log.msg.match("Application does not have permission for this action")) {
                                msg = "This profile is not an Instagram Business or Creator profile";
                                upgradeLink = (
                                    <a href="https://support.dlvrit.com/hc/en-us/articles/1260803288509-How-do-I-change-my-Instagram-Personal-account-to-a-Business-Account-" style={{marginLeft: '10px', textDecoration: 'underline'}} target="_blank">Learn how to change account type</a>
                                );
                            }

                            if (log.msg.match("The user is not an Instagram Business")) {
                                msg = "This post type requires reauthorization for this Instagram profile";
                                upgradeLink = (
                                    <Link to={`/config/socials/detail/${this.props.router.params.socialId}`} style={{marginLeft: '10px', textDecoration: 'underline'}} >Reauthorize Now</Link>);
                            }

                            if (log.msg.match("In replies to conversations you are part of, you may only @mention users who are already participants in the thread")) {
                                // server version has a period, remove it here so it doesn't double up
                                msg = "In replies to conversations you are part of, you may only @mention users who are already participants in the thread";
                                upgradeLink = (
                                    <a href="https://devcommunity.x.com/t/x-api-v2-update-addressing-llm-generated-spam/257909" target="_blank">Learn more.</a>
                                )
                            }


                          return (
                                <li className={logEntryClass} key={`notice-${log.unixTs}-${i}`}>
                                    <div className="log-date">
                                      <DateDisplay
                                          {...this.props}
                                          dateTime={log.unixTs * 1000}
                                          dateTimeFormat="long"
                                          useTimezone={true}
                                          withRelative={true}/>
                                    </div>
                                    <div className="log-message">
                                        {(upgradeLink) ? msg + "." : msg} {upgradeLink}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                );
            }

        }

        return (
            <div>
                {errorBlock}
                {adviceBlock}
                {logBlock}
            </div>
        )

    }

};

SocialLogPanel.displayName = "SocialLogPanel";

export default ComponentWithContext(SocialLogPanel);
